module.exports = __webpack_public_path__ + "img/konzessionsabgaben-header.d2114d9c.png";